<template>
  <div class="category-item">
    <div class="form-check d-flex align-items-center">
      <input
        class="form-check-input"
        type="checkbox"
        :checked="modelValue.includes(category.id)"
        :id="'cat-' + category.id"
        @change="toggle"
      />
      <label class="form-check-label ms-2" :for="'cat-' + category.id">
        {{ category.name }}
      </label>
    </div>
    <div
      v-if="category.children && category.children.length > 0"
      class="ms-4 border-start ps-2"
    >
      <category-item
        v-for="child in category.children"
        :key="child.id"
        :category="child"
        :ancestors="childAncestors"
        v-model="model"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryItem",
  props: {
    category: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    ancestors: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    childAncestors() {
      return [...this.ancestors, this.category.id];
    },
  },
  methods: {
    toggle(e) {
      const checked = e.target.checked;
      const ids = new Set(this.modelValue);

      // Helper to collect all descendant IDs recursively
      const collect = (cat) => {
        if (checked) ids.add(cat.id);
        else ids.delete(cat.id);
        if (cat.children) {
          cat.children.forEach(collect);
        }
      };

      collect(this.category);

      // If checking, also add all ancestors
      if (checked) {
        this.ancestors.forEach((id) => ids.add(id));
      }

      this.$emit("update:modelValue", Array.from(ids));
    },
  },
};
</script>

<style scoped>
.category-item {
  margin-bottom: 0.5rem;
}
.form-check {
  min-height: auto;
  margin-bottom: 0;
}
</style>
